import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import pubSub from '../../util/pubSub';
import { throttle } from '../../util/decorators';
import breakpoints from '../../util/breakpoints';
import StoryNavItem from './StoryNavItem.jsx';

const mapStateToProps = state => ({
  windowSize: state.events.windowSize,
  displayAdUpdate: state.ads.displayAdUpdate,
  breakpoint: state.events.breakpoint,
});

@connect(mapStateToProps)
export default class StoryNav extends React.PureComponent {
  static propTypes = {
    articles: React.PropTypes.array.isRequired,
    windowSize: React.PropTypes.shape({
      width: React.PropTypes.number.isRequired,
      height: React.PropTypes.number.isRequired,
    }).isRequired,
    breakpoint: React.PropTypes.number,
    skipPathUpdate: React.PropTypes.bool,
  };

  constructor() {
    super();

    this.state = {
      scrollTop: 0,
      showMobileStoryNav: false,
      isLastItem: false,
    };
  }

  componentDidMount() {
    if (this.props.articles && this.props.articles.length > 0) {
      this.storyWidth = this.refs.storyNav.getElementsByTagName('li')[0].clientWidth;
      this.calculateVisibleStories();
    }

    this.autoScrollSubscription = pubSub.subscribe('activeStoryNav', (itemIndex) => {
      const firstVisibleStory = Math.ceil(this.refs.storyNav.scrollLeft / this.storyWidth);
      const lastVisibleStory = Math.floor((this.refs.storyNav.scrollLeft + this.props.windowSize.width) / this.storyWidth);

      // Only show next item on smaller devices.
      const index = this.props.breakpoint < breakpoints.SM ? itemIndex + 1 : itemIndex;
      const shiftIndex = this.props.breakpoint < breakpoints.SM ? 0 : 1;

      if (index >= lastVisibleStory) {
        this.refs.storyNav.scrollLeft += (this.numberOfVisibleStories - shiftIndex) * this.storyWidth;
      } else if (index < firstVisibleStory) {
        this.refs.storyNav.scrollLeft -= this.storyWidth;
      }
      this.setState({
        isLastItem: index === lastVisibleStory,
      });
    });

    this.scrollSubscription = pubSub.subscribe('scroll', (scrollTop) => {
      this.updateScrollTop(scrollTop);
    });

    this.showMobileStoryNav = pubSub.subscribe('showMobileStoryNav', (showMobileStoryNav) => {
      this.setState({
        showMobileStoryNav,
      });
    });
  }

  componentWillReceiveProps({ windowSize }) {
    if (this.props.windowSize.width !== windowSize.width) {
      this.calculateVisibleStories();
    }
  }

  componentWillUnmount() {
    this.autoScrollSubscription.remove();
    this.scrollSubscription.remove();
    this.showMobileStoryNav.remove();
  }

  @throttle(100)
  updateScrollTop(scrollTop) {
    this.setState({
      scrollTop,
    });
  }

  calculateVisibleStories() {
    this.numberOfVisibleStories =
      this.props.breakpoint < breakpoints.SM ? 1 : Math.ceil(this.props.windowSize.width / this.storyWidth);
  }

  render() {
    const { articles } = this.props;
    return (
      <ul
        className={cx({
          'mobile-story-nav': this.props.breakpoint < breakpoints.SM,
          'disabled': !this.state.showMobileStoryNav || this.state.isLastItem,
          'story-nav': true,
        })}
        id="story-nav"
        ref="storyNav">
        {
          articles && articles.length > 0 && articles[0] !== null &&
            articles.map((article, index) => (
              <li className={cx({
                'mobile-story-nav': this.props.breakpoint < breakpoints.SM,
              })}
              key={article.id}>
                <StoryNavItem
                  skipPathUpdate={this.props.skipPathUpdate}
                  article={article}
                  windowSize={this.props.windowSize}
                  displayAdUpdate={this.props.displayAdUpdate}
                  scrollTop={this.state.scrollTop}
                  index={index}
                />
              </li>
            ))
        }
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/ArticleFeed/StoryNav.jsx